import { FourierFilm } from "./FourierHeart";
import { catModel } from "./catModel";
import { catTheme } from "./catTheme";

export const FourierCat = () => (
    <FourierFilm
      model={catModel}
      targetLabel="TRACED CAT"
      centerFinal
      colors={catTheme.colors}
      timing={catTheme.timing}
      skipIntroCopy
      flatStyle
      outroText={["THIS IS", "FOURIER CAT"]}
    />
);
